
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Editor from 'wangeditor'
import MaterialSelect from '@/components/material-select/index.vue'
import { getRandomString } from '@/utils/util'

@Component({ components: { MaterialSelect } })
export default class LsEditor extends Vue {
    $refs!: { materialSelect: any }

    @Prop() value!: string
    @Prop({ default: 600 }) height!: number
    @Prop() width!: number

    firstData = true
    editor!: Editor
    identify = ''

    get editStyle () {
      return this.width ? { width: `${this.width}px` } : {}
    }

    @Watch('value')
    valueChange (value: string) {
      if (this.firstData && this.editor) {
        this.firstData = false
        this.editor.txt.html(value || '')
      }
    }

    created () {
      this.identify = `editor-${getRandomString(3)}`
    }

    mounted () {
      this.editor = new Editor(`#${this.identify}`)
      this.editor.config.height = this.height
      this.editor.config.menus = [
        'head',
        'bold',
        'fontSize',
        'italic',
        'underline',
        'strikeThrough',
        'indent',
        'lineHeight',
        'foreColor',
        'link',
        'list',
        'justify',
        'quote',
        'image',
        'undo',
        'redo'
      ]
      this.editor.config.menuTooltipPosition = 'down'
      this.editor.config.showFullScreen = false
      this.editor.config.showLinkImg = false
      this.editor.config.uploadImgShowBase64 = true
      this.editor.config.zIndex = 1
      this.editor.config.uploadImgFromMedia = () => this.$refs.materialSelect.showDialog()
      this.editor.config.onchange = (html: string) => {
        this.firstData = false
        this.$emit('input', html)
      }
      this.editor.create()
      if (this.firstData && this.value) {
        this.firstData = false
        this.editor.txt.html(this.value)
      }
    }

    handleChange (values: string[]) {
      values.forEach(value => {
        this.editor.cmd.do('insertHTML', `<img src="${value}" style="max-width:100%;"/>`)
      })
    }

    beforeDestroy () {
      this.editor.destroy()
    }
}
